import React from 'react';
import { Send } from 'lucide-react';

const TelegramButton = () => {
  return (
    <a
      href="https://t.me/XtreamStore"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 right-6 z-50 group"
      data-testid="telegram-join-button"
    >
      <div className="relative">
        {/* Telegram Button */}
        <div className="w-14 h-14 rounded-full bg-[#0088cc] hover:bg-[#0077b3] text-white shadow-lg flex items-center justify-center transition-all hover:scale-110">
          <Send className="w-6 h-6" />
        </div>
        
        {/* Tooltip */}
        <div className="absolute right-16 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          <div className="bg-[#121214] border border-white/10 rounded-lg px-4 py-2 whitespace-nowrap shadow-xl">
            <p className="text-sm font-bold">Join our Telegram</p>
            <p className="text-xs text-muted-foreground">Get updates & offers</p>
          </div>
          {/* Arrow */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full">
            <div className="w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[6px] border-l-white/10"></div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default TelegramButton;
